import { Formik } from "formik";
import * as Yup from "yup";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  TertiaryHeading,
  fontFamilyMedium,
  lightBlue4,
  lightDark3,
  title,
} from "../../components/GlobalStyle";
import FormControl from "../../components/FormControl";
import { CreateTransactionStyle } from "./style";
import CustomButton from "../../components/CustomButton/CustomButton";
import { Form } from "antd";
import usePostEvent from "../../hooks/usePostEvent";
import { create_translation_url } from "../../utils/api_urls";
import { useState } from "react";
import CustomModal from "../../components/Modal/CustomModal";
import MartailModal from "../../components/CustomModals/MartailModal";
import { useGlobalContext } from "../../context/context";
import { PortalType } from "./type";

// initial values types
export type transactionValuesType = {
  roleType: "USER" | "Student" | "SCHOOL" | "ADMIN";
  screenName: string;
  labelKey: string;
  en: string;
  es: string;
  pt: string;
  ar: string;
  ur: string;

  zh: string;
  hi: string;
  bn: string;
  ru: string;
  fr: string;
  de: string;
  ja: string;
  pa: string;
  sw: string;
  te: string;
  mr: string;
  ind: string;
};

const CreateTransaction = () => {
  const navigate = useNavigate();
  const { loading, data, error, apiDataPromise } = usePostEvent();
  const [showModal, setShowModal] = useState(false);
  const { portalType } = useGlobalContext();

  // initial values
  const initialValues: transactionValuesType = {
    roleType: portalType as PortalType,
    screenName: "",
    labelKey: "",
    en: "",
    es: "",
    pt: "",
    ar: "",
    ur: "",
    zh: "",
    hi: "",
    bn: "",
    ru: "",
    fr: "",
    de: "",
    ja: "",
    pa: "",
    sw: "",
    te: "",
    mr: "",
    ind: "",
  };

  // validation schema
  const validationSchema = Yup.object({
    roleType: Yup.string().required("Field is required!"),
    screenName: Yup.string().required("Field is required!"),
    labelKey: Yup.string().required("Field is required!"),
    en: Yup.string().required("Field is required!"),
    es: Yup.string().optional(),
    pt: Yup.string().optional(),
    ar: Yup.string().optional(),
    ur: Yup.string().optional(),
    zh: Yup.string().optional(),
    hi: Yup.string().optional(),
    bn: Yup.string().optional(),
    ru: Yup.string().optional(),
    fr: Yup.string().optional(),
    de: Yup.string().optional(),
    ja: Yup.string().optional(),
    pa: Yup.string().optional(),
    sw: Yup.string().optional(),
    te: Yup.string().optional(),
    mr: Yup.string().optional(),
    ind: Yup.string().optional()
  });
  // handle submit
  const handleSubmit = async (values: transactionValuesType) => {
    await apiDataPromise(create_translation_url, values);

    setShowModal(true);
    setTimeout(() => {
      setShowModal(false);
      navigate("/translation-list?portal=USER&page=1");
    }, 2000);
  };
  return (
    <CreateTransactionStyle>
      <CustomModal
        isModalVisible={showModal}
        setIsModalVisible={setShowModal}
        showCloseBtn={false}
      >
        <MartailModal
          doTask={() => {
            navigate("/portal=USER&page=1");
            setShowModal(false);
          }}
          title="Translation Created"
          description="Transalation created successfully!"
        />
      </CustomModal>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => {
          return (
            <Form onFinish={formik.handleSubmit} className="pb-2">
              <Row id="mt-20">
                <TertiaryHeading>Create Translations</TertiaryHeading>
                <Row>
                  <Col>
                    <div id="mt-20">
                      <FormControl
                        control="input"
                        type="text"
                        name="screenName"
                        color={lightDark3}
                        padding="8px"
                        label="Screen Name"
                        placeholder="Enter Screen Name"
                        className={
                          formik.errors.screenName && formik.touched.screenName
                            ? "is-invalid"
                            : "customInput"
                        }
                      />
                    </div>
                  </Col>
                  <Col>
                    <div id="mt-20">
                      <FormControl
                        control="input"
                        type="text"
                        name="labelKey"
                        color={lightDark3}
                        padding="8px"
                        label="Label Key Name"
                        placeholder="Enter Label Key Name"
                        className={
                          formik.errors.labelKey && formik.touched.labelKey
                            ? "is-invalid"
                            : "customInput"
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="en"
                    color={lightDark3}
                    padding="8px"
                    label="English"
                    placeholder="Enter Content"
                    className={
                      formik.errors.en && formik.touched.en
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="pt"
                    color={lightDark3}
                    padding="8px"
                    label="Português"
                    placeholder="Insira o conteúdo"
                    className={
                      formik.errors.pt && formik.touched.pt
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="es"
                    color={lightDark3}
                    padding="8px"
                    label="española"
                    placeholder="Insira o conteúdo"
                    className={
                      formik.errors.es && formik.touched.es
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>

                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="bn"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="Bengala"
                    placeholder="অনুগ্রহ করে পাঠ্য লিখুন"
                    className={
                      formik.errors.bn && formik.touched.bn
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>

                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="ru"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="Russian"
                    placeholder="Пожалуйста, введите текст"
                    className={
                      formik.errors.ru && formik.touched.ru
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>

                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="fr"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="French"
                    placeholder="S’il vous plaît entrer du texte"
                    className={
                      formik.errors.fr && formik.touched.fr
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="de"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="German"
                    placeholder="Bitte geben Sie den Text ein"
                    className={
                      formik.errors.de && formik.touched.de
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="ja"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="Japanese"
                    placeholder="テキストを入力してください"
                    className={
                      formik.errors.ja && formik.touched.ja
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="pa"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="Punjabi"
                    placeholder="ਕਿਰਪਾ ਕਰਕੇ ਟੈਕਸਟ ਦਾਖਲ ਕਰੋ"
                    className={
                      formik.errors.pa && formik.touched.pa
                        ? "is-invalid"
                        : "customInput"
                    }

                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="sw"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="Swahili"
                    placeholder="Tafadhali ingiza maandishi"
                    className={
                      formik.errors.sw && formik.touched.sw
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="te"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="Telugu"
                    placeholder="مواد درج کریں۔"
                    className={
                      formik.errors.te && formik.touched.te
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="mr"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="Marathi"
                    placeholder="कृपया मजकूर प्रविष्ट करा"
                    className={
                      formik.errors.mr && formik.touched.mr
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="zh"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="Chinese"
                    placeholder="请输文字"
                    className={
                      formik.errors.zh && formik.touched.zh
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="hi"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="Hindi"
                    placeholder="कृपया पाठ दर्ज करें"
                    className={
                      formik.errors.hi && formik.touched.hi
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="ind"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="Indonesian"
                    placeholder="Silakan masukkan teks"
                    className={
                      formik.errors.ind && formik.touched.ind
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="ar"
                    color={lightDark3}
                    padding="8px"
                    label="عربي"
                    textAlign="end"
                    labelAlign="end"
                    fontFamily={fontFamilyMedium}
                    placeholder="أدخل المحتوى"
                    className={
                      formik.errors.ar && formik.touched.ar
                        ? "is-invalid"
                        : "customInput"
                    }
                  />
                </Col>
                <Col sm={12} id="mt-20">
                  <FormControl
                    control="input"
                    type="text"
                    name="ur"
                    color={lightDark3}
                    fontFamily={fontFamilyMedium}
                    padding="8px"
                    label="اردو"
                    placeholder="مواد درج کریں۔"
                    className={
                      formik.errors.ur && formik.touched.ur
                        ? "is-invalid"
                        : "customInput"
                    }
                    textAlign="end"
                    labelAlign="end"
                  />
                </Col>

              </Row>
              <div className="d-flex justify-content-end mt-20">
                <CustomButton
                  bgcolor={lightBlue4}
                  color={title}
                  padding="8px"
                  width="452px"
                  type="submit"
                  title="Create"
                  margin="auto"
                  loading={loading}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </CreateTransactionStyle>
  );
};

export default CreateTransaction;
